import React from 'react';
import { Tag, Tooltip } from 'antd';

interface TagDisplayProps {
  tags?: API.Term[];
  maxVisible?: number;
  size?: 'small' | 'default';
  style?: React.CSSProperties;
  onClick?: (tag: API.Term) => void;
  showTooltip?: boolean;
}

const TagDisplay: React.FC<TagDisplayProps> = ({
  tags = [],
  maxVisible = 3,
  size = 'small',
  style,
  onClick,
  showTooltip = true,
}) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  const visibleTags = tags.slice(0, maxVisible);
  const hiddenCount = tags.length - maxVisible;

  const renderTag = (tag: API.Term, index: number) => {
    const icons: string[] = Array.isArray(tag.meta?.icons) ? tag.meta.icons : [];
    const tagElement = (
      <Tag
        key={tag.id || index}
        color={tag.color}
        style={{
          fontSize: size === 'small' ? 12 : undefined,
          marginRight: 4,
          marginBottom: 4,
          borderRadius: 4,
          cursor: onClick ? 'pointer' : 'default',
        }}
        onClick={() => onClick?.(tag)}
      >
        {icons.length > 0 && <span style={{ marginRight: 3 }}>{icons.join('')}</span>}
        {tag.name}
      </Tag>
    );

    if (showTooltip && tag.description) {
      return (
        <Tooltip key={tag.id || index} title={tag.description}>
          {tagElement}
        </Tooltip>
      );
    }

    return tagElement;
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', ...style }}>
      {visibleTags.map(renderTag)}
      
      {hiddenCount > 0 && (
        <Tooltip
          title={
            <div>
              {tags.slice(maxVisible).map((tag, index) => (
                <div key={tag.id || index} style={{ marginBottom: 2 }}>
                  {tag.name}
                </div>
              ))}
            </div>
          }
        >
          <Tag
            style={{
              fontSize: size === 'small' ? 12 : undefined,
              backgroundColor: '#f0f0f0',
              color: '#666',
              border: '1px dashed #d9d9d9',
              borderRadius: 4,
            }}
          >
            +{hiddenCount} more
          </Tag>
        </Tooltip>
      )}
    </div>
  );
};

export default TagDisplay;
